import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import CreateCartRuleForm from './CreateCartRuleForm';
import EditCartRuleForm from './EditCartRuleForm';
import CartRuleList from './CartRuleList';
import { axiosRequestPostmenJSONFields } from '../../../actions/user/postmen';
import { handleAxiosErrors } from '../../../_utils';

function CartRule(props) {
    const {
        isLoadingList,
        list,
        handleCreate,
        handleEdit,
        handleDelete,
        request,
    } = props;
    const [showForm, setShowForm] = useState('default');
    // const [cartRuleFieldList, setCartRuleFieldList] = useState({});
    // const [cartRuleOptions, setCartRuleOptions] = useState([]);
    const [selectedCartRuleOption, setSelectedCartRuleOption] = useState('');
    const [editCartRule, setEditCartRule] = useState({});
    // TODO
    // const requestPostmenJson = () => {
    //     return axiosRequestPostmenJSONFields()
    //         .then((response) => {
    //             const shippers = response.data['shippers'];
    //             const options = Object.keys(shippers).map((shipper) => {
    //                 return {
    //                     value: shipper,
    //                     label: shippers[shipper]['name'],
    //                 };
    //             });

    //             setCartRuleOptions([
    //                 {
    //                     value: '',
    //                     label: 'Select a carrier',
    //                 },
    //                 ...options,
    //             ]);

    //             // need a selector
    //             setCartRuleFieldList(shippers);
    //         })
    //         .catch((error) => {
    //             handleAxiosErrors(error);
    //         });
    // };

    // Initial request
    useEffect(() => {
        if(request) {
            request();
        }
    }, []);

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-freight-options' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage id={'ACCOUNT_CARTRULE.HEADING'} />
                </h3>
            </div>
            {/* <div className='vspace vspace--small'>
                <div className='text-box'>
                    <p>
                        <LocalizedMessage id={'ACCOUNT_CARTRULE.CONTENT'} />
                    </p>
                </div>
            </div> */}
            <div className='row'>
                <div className='col-xs-12 col-md-7'>
                    <div className='vspace vspace--small'>
                        <CartRuleList
                            isLoading={isLoadingList}
                            list={list}
                            onEditClick={(row) => {
                                setEditCartRule(row.original);
                                setShowForm('edit');
                            }}
                            onRemoveClick={handleDelete}
                            setShowForm={setShowForm}
                            showForm={showForm}
                        />
                    </div>

                    <div className='tab-content react-component'>
                        <div
                            id='default-address-form'
                            className={classnames(
                                'tab-pane',
                                showForm === 'default' && 'active'
                            )}
                        >
                            <button
                                type='button'
                                className='button button-filter button--grey-border'
                                onClick={() => setShowForm('add')}
                            >
                                <span className='icon icon-plus-thick' />
                                <span>
                                    <LocalizedMessage
                                        id={'ACCOUNT_CARTRULE.ADD_NEW'}
                                    />
                                </span>
                            </button>
                        </div>
                        <div
                            id='add-cart-rule-form'
                            className={classnames(
                                'tab-pane',
                                showForm === 'add' && 'active'
                            )}
                        >
                            <CreateCartRuleForm
                                handleCreate={handleCreate}
                                closeForm={() => setShowForm('default')}
                            />
                        </div>
                        <div
                            id='edit-cart-rule-form'
                            className={classnames(
                                'tab-pane',
                                showForm === 'edit' && 'active'
                            )}
                        >
                            {showForm === 'edit' && 'active' && (
                                <EditCartRuleForm
                                    handleEdit={handleEdit}
                                    closeForm={() => setShowForm('default')}
                                    showForm={showForm}
                                    editCartRule={editCartRule}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CartRule;
